export default __webpack_public_path__ + "img/KJEbzISs.2284bc5c.svg";